import { FIRST_VISIT } from "store/types";

export const firstVisit = () => ({
  type: FIRST_VISIT
});